import { render, staticRenderFns } from "./pVioce.vue?vue&type=template&id=aa22668e&scoped=true"
import script from "./pVioce.vue?vue&type=script&lang=js"
export * from "./pVioce.vue?vue&type=script&lang=js"
import style0 from "./pVioce.vue?vue&type=style&index=0&id=aa22668e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa22668e",
  null
  
)

export default component.exports